import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Select from 'react-select'

export default class SelectInput extends Component {
  onChange(e) {
    const { onChange } = this.props

    if (onChange === null) {
      return
    }

    const { value } = e

    if (value === undefined) {
      return
    }

    onChange(value)
  }

  render() {
    const { className, objects, selected, selectId, selectName, placeholder } = this.props
    const options = objects.map(o => ({
      label: o.name,
      value: o.id
    }))

    return (
      <Select
        className={classnames(className, 'react-select-container')}
        classNamePrefix="react-select"
        inputId={selectId}
        name={selectName}
        options={options}
        defaultValue={{ label: selected.name, value: selected.id }}
        placeholder={placeholder}
        onChange={e => this.onChange(e)}
        noOptionsMessage={() => null}
      />
    )
  }
}

SelectInput.propTypes = {
  className: PropTypes.string,
  objects: PropTypes.arrayOf(PropTypes.object).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  selected: PropTypes.object.isRequired,
  selectId: PropTypes.string.isRequired,
  selectName: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  onChange: PropTypes.func
}

SelectInput.defaultProps = {
  className: null,
  onChange: null
}
